import { FC } from 'react'
import styled from 'styled-components'
import { Close } from 'svgIcons'

interface IFCloseButtonProps {
  onClick: () => void
  className?: string
}

const CloseButton: FC<IFCloseButtonProps> = ({ onClick, className }) => {
  return (
    <StyledWrapper onClick={onClick} className={className}>
      <Close />
    </StyledWrapper>
  )
}

export default CloseButton

const StyledWrapper = styled.div``
